var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-signature"},[_c('label',{staticClass:"input-title"},[_vm._v(_vm._s(_vm.getTitle(_vm.component.name)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }